module.exports = __webpack_public_path__ + "src/assets/images/target.svg?159d366bd9c269c445b15eaf764b80f2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/target.svg
// module id = 1062
// module chunks = 1